import { render, staticRenderFns } from "./AdminContrattiIdView.vue?vue&type=template&id=178566de&"
import script from "./AdminContrattiIdView.vue?vue&type=script&lang=ts&"
export * from "./AdminContrattiIdView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports